import 'css-chunksrc/client/pages/calendarPage/sideBar/loader/styles.scss';export default {
  "loader": "_loader_1tdxe_1",
  "title": "_title_1tdxe_12",
  "projects": "_projects_1tdxe_17",
  "item": "_item_1tdxe_22",
  "legend": "_legend_1tdxe_27",
  "row": "_row_1tdxe_35",
  "pellet": "_pellet_1tdxe_41",
  "footer": "_footer_1tdxe_49"
};